import React, { useRef } from 'react';
import BandLayoutPage from '../components/partial/layout/BandLayoutPage.jsx';
import PerformerNavEditTags from '../components/partial/navigation/PerformerNavEditTags.jsx';
import PerformerEditTags from '../components/partial/PerformerEditTags.jsx';
import { EditTagsSearchProvider } from '../contexts/EditTagsSearchContext.jsx';

const EditTagsPageWrapper = () => {
  const resetTagFilterRef = useRef(null);

  const handleSearchPerformed = () => {
    // Reset tag filter when a search is performed
    if (resetTagFilterRef.current) {
      resetTagFilterRef.current();
    }
  };

  return (
    <EditTagsSearchProvider onSearchPerformed={handleSearchPerformed}>
      <BandLayoutPage
        navigation={<PerformerNavEditTags />}
        pageType="song-list"
      >
        <PerformerEditTags resetTagFilterRef={resetTagFilterRef} />
      </BandLayoutPage>
    </EditTagsSearchProvider>
  );
};

export default EditTagsPageWrapper;